import types from './actionTypes'

export const searchWithKeyword = (keyword) => ({
  type: types.SEARCH_USER,
  data: keyword
})

export const getUserProfile = memberId => ({
  type: types.SEARCH_GET_MEMBER,
  data: memberId
})

export const loadPointHistory = card_id => ({
  type: types.LOAD_HISTORY,
  data: card_id
})

export const loadAvailablePrivilege = memberId => ({
  type: types.LOAD_PRIVILEGE,
  data: memberId
})

export const claimPrivilege = (memberId, id, params, amount) => ({
  type: types.USE_PRIVILEGE,
  data: {
    memberId,
    id,
    params,
    amount
  }
})

export const confirmCodeUse = (memberId, pid, code, password) => ({
  type: types.CONFIRM_PRIVILEGE_USE,
  data: {
    memberId,
    pid,
    password,
    code
  }
})

export const activateCard = (memberId, cardId, secret, cb) => ({
  type: types.ACTIVATE_CARD,
  data: {
    memberId,
    cardId,
    secret,
    cb
  }
})

export default {
  searchWithKeyword,
  getUserProfile,
  loadPointHistory,
  loadAvailablePrivilege,
  claimPrivilege,
  confirmCodeUse,
  activateCard
}


// WEBPACK FOOTER //
// ./src/containers/Search/store/actions.js